import { createContext, useContext, useState } from 'react'
import Notification from '../components/Notifications/Notification'

const NotificationContext = createContext()

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    show: false,
    message: '',
    type: 'info'
  })

  const showNotification = (message, type = 'info') => {
    setNotification({ show: true, message, type })
    setTimeout(() => {
      hideNotification()
    }, 5000)
  }

  const hideNotification = () => {
    setNotification({ show: false, message: '', type: 'info' })
  }

  return (
    <NotificationContext.Provider
      value={{ showNotification, hideNotification }}
    >
      {children}
      {notification.show && (
        <Notification
          type={notification.type || ''}
          text={notification.message}
          handleClose={hideNotification}
        />
      )}
    </NotificationContext.Provider>
  )
}

export const useNotification = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error(
      'useNotification must be used within a NotificationProvider'
    )
  }
  return context
}
